import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ItemsListRowItemIconAComponent } from '../icon-a/icon-a.component';

@Component({
    selector: 'fi-items-list-row-item-image-icon-a',
    templateUrl: './image-icon-a.component.html',
    styleUrls: ['./image-icon-a.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItemsListRowItemImageIconAComponent extends ItemsListRowItemIconAComponent {}
